/**
 * Next's app router stores internal route tree data in `window.history.state`.
 * Passing `null` or `{}` to `replaceState` clobbers that data and can make the
 * next app-router navigation fail with "initialTree is not iterable".
 */
export function replaceUrlPreservingNextHistoryState(url: string) {
  window.history.replaceState(window.history.state, '', url)
}
